import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { StorageService } from '../_services/storage.service';
import { AuthService } from '../_services/auth.service';
import { Router } from '@angular/router';
 
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
 
  constructor(private router: Router,private storageService: StorageService, private authService : AuthService) { };
 
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
 
    const USER_TOKEN = this.storageService?.getUserToken();
    let loggIn = localStorage.getItem('csrf')
    // se ti sei loggato in precedenza conserva i cookie
    if(loggIn){
      req = req.clone({
        withCredentials: true,
      });
    }
    if(USER_TOKEN){
      req = req.clone({
        withCredentials: true,
        setHeaders: {
          Authorization: `Bearer ${USER_TOKEN.replace(/"/g,'')}`
        }
      });
      
    }
    return next.handle(req).pipe(catchError(err => {
      if (err.status === 401) {
        this.authService.logout();
        this.storageService.clean();
        this.router.navigate(['/login']);
 
      }
 
      if (err.status === 403 || err.status === 404) {
          this.router.navigate(['/dashboard/bacheca']);
      }
        const error = err || err.statusText;
          return throwError(error);
    }))
 
  }
}
 
export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
];